module.exports = "fragment ItemizedCostFragment on ItemizedCost {\n  total {\n    ...Price\n  }\n  entries {\n    ...LabeledPrice\n  }\n}\n"